export default {
  title: 'Poster Hall',
  no_results: 'There are no posters that match your filters.',
  poster: 'Poster',
  poster_count: 'No posters | {count} poster | {count} posters',
};
